module.exports = __webpack_public_path__ + "static/media/diva41.03712073.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diva/diva41.jpg
// module id = 587
// module chunks = 0